module.exports = __webpack_public_path__ + "img/10891_L.9c762e08.png";